import { DateTime } from "luxon";
export function MetarsRequest_toTransferable({ icao, startDateTime, endDateTime }) {
    return {
        icao,
        startDateTime: startDateTime.toISO(),
        endDateTime: endDateTime.toISO(),
    };
}
export function MetarsRequest_fromTransferable({ icao, startDateTime, endDateTime }) {
    return {
        icao,
        startDateTime: DateTime.fromISO(startDateTime),
        endDateTime: DateTime.fromISO(endDateTime),
    };
}
//# sourceMappingURL=MetarsRequest.js.map